<!-- <p-chips [formControl]="this.form.get('tagsControl')" (onAdd)="addNovaTag($event)"></p-chips> -->
<div class="mt-2">
  <mat-form-field class="w-100 mb-2" appearance="outline">
    <mat-label>{{ placeholder }}</mat-label>
    <mat-chip-grid #chipListTag>
      @for (tag of formTag.controls; track tag) {
        <mat-chip-row
          [removable]="true"
          class="chip-item"
          (removed)="removerTag(tag)"
        >
          <!-- [selectable]="true" -->
          <!-- [ngStyle]="{ 'background-color': color ? color : tag.value.color, color: 'white' }" -->
          <!-- {{ tag.value.value }} -->
          {{ tag.value }}
          <!-- [ngStyle]="{ 'background-color': color ? color : tag.value.color, color: 'white' }" -->
          <mat-icon matChipRemove>cancel</mat-icon>
        </mat-chip-row>
      }
      <input
        class="field-tag"
        #input
        autocomplete="off"
        [readonly]="formTag.controls.length === 1 && showOnlyOne ? true : false"
        [matChipInputFor]="chipListTag"
        [matChipInputSeparatorKeyCodes]="teclasSeparadoras"
        [matChipInputAddOnBlur]="true"
        (matChipInputTokenEnd)="addNovaTag($event)"
      />
    </mat-chip-grid>
  </mat-form-field>
  <!-- <small class="p-error" *ngIf="form.get('tags').hasError('required')">
    teste
  </small> -->
</div>
